const sentry = require('@sentry/browser');
const createSentryProcessor = require('./processor');

const browserSentry = createSentryProcessor({ sentry });

module.exports = browserSentry;
